export default __webpack_public_path__ + "static/media/Receipt.04b545bd.png";